import PropTypes from 'prop-types';

const sizes = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
  xl: 'w-16 h-16 text-lg',
};

export default function Avatar({ initials, src, alt, size = 'md', className = '' }) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt || 'Avatar'}
        className={`rounded-full object-cover border-2 border-white shadow-sm ${sizes[size]} ${className}`}
      />
    );
  }

  return (
    <div
      className={`flex items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-secondary-700 text-white font-bold border-2 border-white shadow-sm ${sizes[size]} ${className}`}
    >
      {initials?.toUpperCase()}
    </div>
  );
}

Avatar.propTypes = {
  initials: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  className: PropTypes.string,
};
